import { action, atom } from '@reatom/framework'
import * as Scanner from '@tauri-apps/plugin-barcode-scanner'
import i18next from 'i18next'

import { Result } from '@blade/std-lib'
import { Network, selectedNetworkAtom } from '@root/entities/network'
import { WalletAddress } from '@root/entities/wallet'
import {
  QrFlowNotValidAddressError,
  startScanQrFlowEvent,
} from '@root/features/services/scan-qr'
import { tryOrFailSilently } from '@root/shared/lib'
import { showSnackbarAction } from '@root/shared/ui-kit'

export const scanQrOpenAtom = atom(false, 'scanQrOpenAtom')

startScanQrFlowEvent.onCall(async (ctx, { onScanned }) => {
  try {
    const rootEl = document.getElementById('root')

    if (!rootEl) {
      return
    }

    const state = await (async () => {
      const state = await Scanner.checkPermissions()
      if (state !== 'prompt') {
        return state
      }

      const newState = await Scanner.requestPermissions()
      return newState
    })()

    if (state === 'denied') {
      showSnackbarAction(ctx, {
        text: i18next.t('scan.camera-permission-denied'),
        description: i18next.t('scan.camera-permission-denied-description'),
        intent: 'error',
      })
      return
    }

    if (state !== 'granted') {
      return
    }

    rootEl.style.opacity = '0'
    scanQrOpenAtom(ctx, true)
    const result = await Scanner.scan({
      windowed: true,
      formats: [Scanner.Format.QRCode],
    })
    scanQrOpenAtom(ctx, false)
    rootEl.style.opacity = '1'
    const network = ctx.get(selectedNetworkAtom)

    if (Network.validateAddress(network)(result.content)) {
      onScanned(Result.succeed(WalletAddress(result.content)))
    } else {
      showSnackbarAction(ctx, {
        text: i18next.t('scan.invalid-address'),
        intent: 'error',
      })
      onScanned(
        Result.fail(
          new QrFlowNotValidAddressError({
            address: result.content,
            network,
          }),
        ),
      )
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(`Unable to scan QR code: ${error}`)

    showSnackbarAction(ctx, {
      text: i18next.t('common.something-went-wrong'),
      description: i18next.t('scan.unable-to-scan-qr-code'),
      intent: 'error',
    })
  }
})

export const closeScanQrAction = action((ctx) => {
  tryOrFailSilently(() => Scanner.cancel())
  scanQrOpenAtom(ctx, false)

  const rootEl = document.getElementById('root')

  if (!rootEl) {
    return
  }
  rootEl.style.opacity = '1'
}, 'closeScanQrAction')
